export default "__VITE_PUBLIC_ASSET__2c42ed34__"